import React, { Component } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import app from 'containers/app'
import * as OrgSelectors from 'app/modules/org/selectors'
import withNotifications from 'components/shared/notifications'
import { fetchOrg, fetchOrgProperties } from 'app/modules/org/actions'
import { refreshCurrentUser } from 'app/modules/user/actions'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import ACCESS from 'utils/Access'

import './style.styl'

const HELP_DOC_URL = "https://help.drift.com/article/eloqua-&-drift/"

class EloquaIntegrationPage extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  refreshProperties = () => {
    return this.props.actions.fetchOrgProperties()
  }

  refreshGates = () => {
    return this.props.actions.refreshCurrentUser()
  }

  onConnectClicked = () => {
    this.context.router.push('/settings/setup/eloqua-config')
  }

  render() {
    const isConnected = this.props.data.installed

    return (
      <div className="eloqua-integration-page">
        <p className="integration-page-description">
          Using Eloqua? Seamlessly add Drift in to your existing workflow.
          With our integration you’ll enrich your team’s Drift experience by syncing Eloqua contact information and pushing Drift leads into Eloqua.
        </p>
        <p className="integration-page-description">
          Want more info? Check out our help doc here: <a target="_blank" href={HELP_DOC_URL}>Eloqua & Drift</a>
        </p>
        {isConnected &&
          <Link to="/settings/eloqua/config" className="integration-config-link">
            <h2 className="integration-section-title">
              Synced Eloqua Data
            </h2>
            <p>Choose which data is sent between Eloqua and Drift.</p>
          </Link>
        }
        {isConnected &&
          <Link to="/settings/eloqua/mapping/attributes" className="integration-config-link">
            <h2 className="integration-section-title">
              Mapped Eloqua Attributes
            </h2>
            <p>Map which fields you want to sync between Drift and Eloqua.</p>
          </Link>
        }
        {isConnected &&
          <Link to="/settings/eloqua/mapping/attributes/cdo" className="integration-config-link">
            <h2 className="integration-section-title">
              Mapped CDO Attributes
            </h2>
            <p>Map which fields you want to sync to Eloqua CDOs</p>
          </Link>
        }
        {isConnected &&
          <Link to="/settings/eloqua/event-log" className="integration-config-link">
            View Eloqua Event Log
          </Link>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  orgProperties: OrgSelectors.properties(state),
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ fetchOrg, fetchOrgProperties, refreshCurrentUser }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(
  withNotifications(EloquaIntegrationPage)
)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/EloquaIntegrationPage/index.js